export const languages = ['en', 'de', 'it', 'fr'] as const

export const DEFAULT_LANGUAGE = 'en'

export const LOCALE_COOKIE = 'LocaleSetting'
